import React, { FC } from 'react'
import { Calendar } from '../types'
import PointOfContactLines from 'pages/_serverRendered/HomeownerSiteVisit/components/PointOfContactLines'

type PointOfContactProps = {
  calendar: Calendar
}

const PointOfContact: FC<PointOfContactProps> = ({ calendar }) => {
  return (
    <div className="tw:p-4 tw:pt-6 tw:flex tw:flex-col tw:items-center tw:bg-white tw:rounded-4xl tw:border tw:border-neutrals-300">
      <div className="tw:text-sm tw:font-semibold tw:text-tertiary-black tw:w-full">{'Realm Point of Contact'}</div>
      <div className="tw:w-full tw:mt-2">
        <PointOfContactLines calendar={calendar} />
      </div>
    </div>
  )
}

export default PointOfContact
